import React from 'react';
import { Column } from '@ant-design/plots';

const AudienceAgeStatsComponent = ({ ageStats = [] }) => {
  const config = {
    data: ageStats,
    isGroup: true,
    xField: 'ageGroup',
    yField: 'value',
    seriesField: 'name',
    dodgePadding: 2,
    label: {
      position: 'middle',
      layout: [
        {
          type: 'interval-adjust-position',
        },
        {
          type: 'interval-hide-overlap',
        },
        {
          type: 'adjust-color',
        },
      ],
    },
  };

  return (
    <div>
      <h6> <strong>Age</strong></h6>
      <div className="d-flex p-2 "
        style={{ height: '300px' }}>
        <Column {...config}
          style={{ width: '100%' }}
        />
      </div>
    </div>
  );
};

export default AudienceAgeStatsComponent;
